/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-09 14:39:41
 * @FilePath: \baishu_react_ui\src\components\BsyIconBtn\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import './index.css'

export default class BsySerialNum extends BsyWidget {

    constructor(props) {
        super({
            ...props,
            waterMark: React.language("widget.sn.placeholder"),
            width: 350,
            baseCls: "bsy-serial-num"
        });
        this.value = props.value;
    }

    getValue = () => {
        return this.value;
    }

    setValue = (v) => {
        this.value = v;
        this.setState({});
    }

    renderDisablePane = (value) => {
        return <div className="bsy_form_item_disable" data-watermark={React.language('content.empty')} >{this.value ? this.value : ''}</div>
    }


    render() {

        const { cssName, waterMark, formMode } = this.options;

        if (formMode === 'edit' && !this.isEnabled()) {
            return this.renderDisablePane()
        }

        return (
            <div className={cssName}
                data-watermark={waterMark ? waterMark : ''}
            >
                {
                    this.value
                }
            </div>
        );
    }
}
